export default {
  isFinalState(state) {
    // 终态正向交易 10（支付成功）、11（支付取消）、12（支付被拒）、20（支付失败）、21（支付超时）
    const orderStatus = state.orderStatus
    return [10, 11, 12, 20, 21].indexOf(orderStatus) > -1
  },
  isCancel(state) {
    // 支付取消
    return state.orderStatus === 11
  },
  isSuccess(state) {
    // 支付成功
    return state.orderStatus === 10
  },
  status(state, getters) {
    // 支付状态：成功/失败/加载中
    // 状态：success/error/loading
    if (getters.isFinalState) {
      return getters.isSuccess ? 'success' : 'error'
    }
    // loading
    return 'loading'
  },
}
